import type { ConditionBlock, VisibleConditionsCombine } from "../types/graph"

/** Défaut historique pour la carte (root `visible_conditions`) : OR entre blocs. */
export const VISIBLE_CONDITIONS_COMBINE_CARD_DEFAULT: VisibleConditionsCombine =
    "or"

/** Défaut historique pour un graphique dans `graph_list` : AND entre blocs. */
export const VISIBLE_CONDITIONS_COMBINE_GRAPH_DEFAULT: VisibleConditionsCombine =
    "and"

/**
 * Blocs `graph_list[].visible_conditions[]` : si `omit_from_graph_selector` est vrai
 * (ou l’ancien champ `exclusive`), le bloc participe au filtre du sélecteur de graphiques.
 * Repli sur `exclusive` pour les documents non encore migrés.
 */
export function blockOmitFromGraphSelector(block: {
    omit_from_graph_selector?: boolean
    /** @deprecated Ancien nom — lecture seule pour rétrocompatibilité */
    exclusive?: boolean
}): boolean {
    return !!(block.omit_from_graph_selector ?? block.exclusive)
}

/**
 * Évalue si les blocs de visibilité sont satisfaits.
 * Dans chaque bloc, toutes les `conditions` sont combinées en ET (comportement inchangé).
 */
export function evaluateVisibleConditionsBlocks(
    blocks: Array<{ conditions: ConditionBlock[] }> | undefined,
    combine: VisibleConditionsCombine | undefined,
    defaultCombine: VisibleConditionsCombine,
    evalCondition: (condition: ConditionBlock) => boolean
): boolean {
    const list = blocks ?? []
    if (list.length === 0) {
        return true
    }
    const mode = combine ?? defaultCombine
    const blockOk = list.map((block) =>
        block.conditions.every((c) => evalCondition(c))
    )
    if (mode === "or") {
        return blockOk.some(Boolean)
    }
    return blockOk.every(Boolean)
}
